module.exports = __webpack_public_path__ + "static/img/1-1Z604142015V6.c21148c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z604142015V6.jpg
// module id = RB1R
// module chunks = 0